import fetch from '@/util/http'

export default {
  /**
   * 获取父分类
   * 接口文档：丢失
   * @param {*} params
   */
  categoryTreePage(params) {
    return fetch.get('category/treeByType', params)
  },
  /**
   * 获取分类
   * 接口文档：丢失
   * @param {*} params
   */
  categoryPage(params) {
    return fetch.get('category/page', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/category.js